import React from 'react'
import { Checkbox, Image, Table, Modal, Label } from 'semantic-ui-react'

import logo from "../../../images/logo/logo-full-black.png";
import defaultLogo from "../../../images/logo/logo-128.png";

import ModalHeader from '../../drive/ModalHeader'
import { dispatch } from '@rematch/core';
import EllipsisTooltip from '../../common/EllipsisTooltip';
import { history } from '../../../helpers'

class AccountSelectionModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    close = async () => {
        let account = this.props.user.accounts.filter(account => { return account.id.toString() === this.props.selectedAccount._id.toString() })[0];
        if (!account.isActive) {
            dispatch.account.setViewAccountFlag(false);
            // await dispatch.account.selectAccount({ accountId: account._id });
            // dispatch.account.setDeActivateAccountModal(true);
        }
        dispatch.account.setViewAccountFlag(false);
    }

    async selectAccount(e, account) {
        if (account.role === "user" && account.isActive === false) {
            dispatch.account.setAccountSelectorLoader(true);
            await dispatch.account.selectAccount({ accountId: account.id });
            dispatch.account.setDeActivateAccountModal(true);
            dispatch.account.getAcountUserWorkspaces({isLoaderEnabled:true})
            await dispatch.notifications.getEventStreamByOrganization({});
        } else if (account.role === "platformAdmin") {
            dispatch.account.setViewAccountFlag(false);
            await dispatch.account.selectAccount({ accountId: account.id });
            history.push('/app/platform/home');
        } else {
            dispatch.account.setAccountSelectorLoader(true);
            await dispatch.account.selectAccount({ accountId: account.id });
            await dispatch.app.setAllOrganizationsAndRedirectToDefault({ accountId: account.id })
            dispatch.account.setViewAccountFlag(false);
            dispatch.app.isDefaultSelected(true)
            await dispatch.account.getAcountUserWorkspaces({isLoaderEnabled:true})
            await dispatch.notifications.getEventStreamByOrganization({});
        }
    }

    markDefault(e, data, accountId) {
        let payload = {
            accountId: accountId,
            default: data.checked
        }
        dispatch.account.setDefaultAccount(payload);
    }

    moveArrayElement = (arr, old_index, new_index) => {
        while (old_index < 0) {
            old_index += arr.length;
        }
        while (new_index < 0) {
            new_index += arr.length;
        }
        if (new_index >= arr.length) {
            var k = new_index - arr.length;
            while ((k--) + 1) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr;
    }
    render() {
        let disableDefault = true;
        let allAccountsList = this.props.user && this.props.user.accounts;

        if (allAccountsList.length > 1) {
            disableDefault = false;
        }


        let filteredAccount = [];
        if (allAccountsList && allAccountsList.length !== 0) {
            let p_admin = allAccountsList.filter((i) => { return i.role === 'platformAdmin' });
            filteredAccount.push(p_admin)
            let c_admin = allAccountsList.filter((i) => { return i.role === 'customerAdmin' })
            filteredAccount.push(c_admin)
            let u_admin = allAccountsList.filter((i) => { return i.role === 'user' })
            filteredAccount.push(u_admin)
            let remaining = allAccountsList.filter((i) => { return i.role !== 'platformAdmin' && i.role !== 'customerAdmin' && i.role !== 'user' })
            filteredAccount.push(remaining)
        }
        let allAccounts = Array.prototype.concat.apply([], filteredAccount);

        if (this.props.allAccounts && this.props.allAccounts.length > 0) {
            this.props.allAccounts.forEach(acc => {
                allAccounts.forEach(userAccount => {
                    if (!acc.id) {
                        acc.id = acc._id;
                    }
                    if (!userAccount.id) {
                        userAccount.id = userAccount._id
                    }
                    if (acc.id.toString() === userAccount.id.toString()) {
                        userAccount.logo = acc.logo;
                        userAccount.name = acc.name;
                        userAccount.workspaceCount = acc.workspaceCount !== -1 ? acc.workspaceCount : 0;
                        userAccount.isActive = acc.isActive;
                    }
                });
            });
        }

        return (
            <Modal
                className="basicModal"
                dimmer={{ className: 'account-selection-dimmer' }}
                open={this.props.open}
                onClose={this.close}
                closeOnEscape={false}
                closeOnDimmerClick={false}
                closeIcon
            >
                <ModalHeader
                    header={<img src={`${logo}`} alt="logo" />}
                />

                <Modal.Content>
                    <Table celled className="semantic-table table">
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan='5'>
                                    Select Account to Continue
                                        </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Account Name</Table.HeaderCell>
                                <Table.HeaderCell>Role</Table.HeaderCell>
                                <Table.HeaderCell>Make Default</Table.HeaderCell>
                                <Table.HeaderCell>Workspaces</Table.HeaderCell>
                                <Table.HeaderCell>Status</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body className="table-body">
                            {
                                allAccounts && allAccounts.map((account, index) => {
                                    return <Table.Row key={index} className='account-selector-table-row'>
                                        <Table.Cell className='cursor-pointer' width={6} onClick={(e) => { this.selectAccount(e, account) }}>
                                            <div className="accountLogoTiny" >
                                                <Image src={account.logo ? account.logo : defaultLogo} />
                                            </div>
                                            <div className="logoName">
                                                <EllipsisTooltip name={account.name} />
                                            </div>
                                        </Table.Cell>
                                        <Table.Cell className='cursor-pointer' onClick={(e) => { this.selectAccount(e, account) }}>
                                            {
                                                account.role === 'platformAdmin' ? 'Platform Admin' :
                                                    account.role === 'customerAdmin' ? 'Account Owner' :
                                                        account.role === 'billingAdmin' ? 'Billing Admin' :
                                                            'Account User'
                                            }
                                        </Table.Cell>

                                        <Table.Cell>
                                            <Checkbox toggle
                                                checked={account.default}
                                                onChange={(e, d) => { this.markDefault(e, d, account.id) }}
                                                disabled={disableDefault || !account.isActive}
                                            />
                                        </Table.Cell>

                                        <Table.Cell className='cursor-pointer' onClick={(e) => { this.selectAccount(e, account) }}>{account.workspaceCount}</Table.Cell>
                                        {
                                            account.isActive ?
                                                <Table.Cell className='cursor-pointer' onClick={(e) => { this.selectAccount(e, account) }}>Active</Table.Cell>
                                                : <Table.Cell>
                                                    <Label className='bg-orange' size="small" style={{ borderRadius: "2em" }} > Deactivated </Label>
                                                </Table.Cell>
                                        }
                                    </Table.Row>
                                })
                            }
                        </Table.Body>
                    </Table>
                </Modal.Content>

            </Modal>
        )
    }
}

export default AccountSelectionModal;